module.exports = __webpack_public_path__ + "img/19.d214108c.png";